module.exports = __webpack_public_path__ + "static/media/production-network-02.94ae2237.jpg";